// Suprimir errores no críticos de ResizeObserver
const suppressResizeObserverError = () => {
  // Manejar errores de consola
  const originalError = console.error;
  console.error = (...args: any[]) => {
    const errorMessage = args[0];
    
    // Suprimir el error específico de ResizeObserver que no afecta la funcionalidad
    if (
      typeof errorMessage === 'string' &&
      (errorMessage.includes('ResizeObserver loop completed with undelivered notifications') ||
       errorMessage.includes('ResizeObserver loop limit exceeded') ||
       errorMessage.includes('ResizeObserver'))
    ) {
      return;
    }
    
    // También verificar si es un objeto Error
    if (errorMessage && typeof errorMessage === 'object' && errorMessage.message) {
      if (errorMessage.message.includes('ResizeObserver')) {
        return;
      }
    }
    
    // Mostrar otros errores normalmente
    originalError.apply(console, args);
  };

  // Manejar errores no capturados de ResizeObserver
  window.addEventListener('error', (event) => {
    if (
      event.message &&
      (event.message.includes('ResizeObserver loop completed with undelivered notifications') ||
       event.message.includes('ResizeObserver loop limit exceeded') ||
       event.message.includes('ResizeObserver'))
    ) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  });

  // Manejar errores no manejados (unhandled promise rejections)
  window.addEventListener('unhandledrejection', (event) => {
    if (
      event.reason &&
      typeof event.reason.message === 'string' &&
      (event.reason.message.includes('ResizeObserver loop completed with undelivered notifications') ||
       event.reason.message.includes('ResizeObserver loop limit exceeded'))
    ) {
      event.preventDefault();
      return false;
    }
  });

  // Método alternativo más agresivo: interceptar ResizeObserver directamente
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends OriginalResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        const wrappedCallback: ResizeObserverCallback = (entries, observer) => {
          try {
            callback(entries, observer);
          } catch (error: any) {
            if (
              error.message &&
              (error.message.includes('ResizeObserver loop completed with undelivered notifications') ||
               error.message.includes('ResizeObserver loop limit exceeded'))
            ) {
              // Suprimir este error específico
              return;
            }
            throw error;
          }
        };
        super(wrappedCallback);
      }
    };
  }
};

export default suppressResizeObserverError; 